import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { History, Clock, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import { CustomerService } from '../../services/customerService';

const ServiceHistory = () => {
  const user = JSON.parse(localStorage.getItem('roadserve_current_user') || '{}');

  const { data: historyData, isLoading } = useQuery({
    queryKey: ['customerServiceHistory', user?.id],
    queryFn: () => CustomerService.getServiceHistory(user?.id),
    enabled: !!user?.id,
  });

  const history = historyData?.data || [];

  const getStatusIcon = (status) => {
    const s = status?.toLowerCase() || '';
    if (s === 'completed' || s === 'delivered') {
      return <CheckCircle size={20} className="text-green-600" />;
    }
    if (s === 'cancelled' || s === 'failed') {
      return <XCircle size={20} className="text-red-600" />;
    }
    if (s === 'pending' || s === 'in_progress') {
      return <Clock size={20} className="text-yellow-600" />;
    }
    return <AlertCircle size={20} className="text-gray-600" />;
  };

  const getStatusColor = (status) => {
    const s = status?.toLowerCase() || '';
    if (s === 'completed' || s === 'delivered') return 'bg-green-100 text-green-700';
    if (s === 'cancelled' || s === 'failed') return 'bg-red-100 text-red-700';
    if (s === 'pending' || s === 'in_progress') return 'bg-yellow-100 text-yellow-700';
    return 'bg-gray-100 text-gray-700';
  };

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Service History</h1>
          <p className="text-gray-600 mt-1">View your past service requests</p>
        </div>
        <div className="flex items-center justify-center py-12">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Service History</h1>
        <p className="text-gray-600 mt-1">View your past service requests</p>
      </div>

      {history.length === 0 ? (
        <div className="bg-white rounded-xl p-12 shadow-sm border border-gray-200 text-center">
          <History size={48} className="mx-auto text-gray-400 mb-4" />
          <p className="text-gray-500">No service history found</p>
        </div>
      ) : (
        <div className="space-y-4">
          {history.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-2">
                    {getStatusIcon(item.status)}
                    <h3 className="font-semibold text-gray-900 text-lg">
                      {item.service_type || 'Service Request'}
                    </h3>
                  </div>
                  {item.description && (
                    <p className="text-sm text-gray-600 mb-2">{item.description}</p>
                  )}
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                    {item.created_at && (
                      <div>
                        <span className="font-medium">Date:</span>{' '}
                        {new Date(item.created_at).toLocaleDateString()}
                      </div>
                    )}
                    {item.amount && (
                      <div>
                        <span className="font-medium">Amount:</span> ₹{Number(item.amount).toLocaleString('en-IN')}
                      </div>
                    )}
                  </div>
                </div>
                <span className={`px-3 py-1 text-xs font-medium rounded ${getStatusColor(item.status)}`}>
                  {item.status || 'Unknown'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServiceHistory;

